import { createContext, FC, ReactNode, useContext } from "react";

import { OrgPageNewsletterDetailOutput } from "@/common/types/trpc";

const InitialNewsletterContext = createContext<OrgPageNewsletterDetailOutput | null>(null);

export const InitialNewsletterProvider: FC<{ newsletter: OrgPageNewsletterDetailOutput; children: ReactNode }> = ({
  newsletter,
  children,
}) => <InitialNewsletterContext.Provider value={newsletter}>{children}</InitialNewsletterContext.Provider>;

export const useInitialNewsletter = () => useContext(InitialNewsletterContext);
